import { SEO } from "@/components/SEO";
import { PageHero } from "@/components/sections/PageHero";
import { IMG } from "@/lib/content";
import { Reveal, MaskedLines, ImageReveal } from "@/components/motion/Reveal";
import { Parallax } from "@/components/motion/Parallax";
import { Trust } from "@/components/sections/Trust";
import { FinalCta } from "@/components/sections/FinalCta";

const VALUES = [
  ["Präzision", "Wir arbeiten nach Checkliste und Blick. Beides."],
  ["Verlässlichkeit", "Ein Termin ist ein Versprechen. Wir halten es."],
  ["Diskretion", "Was wir in Ihren Räumen sehen, bleibt dort."],
  ["Sorgfalt", "Materialien verlangen unterschiedliche Pflege. Wir kennen den Unterschied."],
];

export default function UeberUns() {
  return (
    <>
      <SEO title="Über uns" description="Emini Reinigung ist ein Schweizer Reinigungsunternehmen für Private, Unternehmen und Liegenschaften. Präzise, verlässlich, diskret." path="/ueber-uns" />
      <PageHero label="Über uns" title={["Ordnung.", "Qualität.", "Verlässlichkeit."]} image={IMG.about} imageAlt="Modernes Wohnhaus mit klarer Architektur" lead="Emini Reinigung ist ein Schweizer Reinigungsunternehmen. Wir arbeiten für Private, Unternehmen und Verwaltungen in der Deutschschweiz." />

      <section className="bg-paper py-24 md:py-36">
        <div className="container-x grid lg:grid-cols-12 gap-14">
          <Reveal className="lg:col-span-3"><p className="label text-mute">Haltung</p></Reveal>
          <div className="lg:col-span-8 lg:col-start-5">
            <MaskedLines as="h2" lines={["Wir reinigen.", "Sie müssen sich um", "nichts kümmern."]} className="display text-3xl sm:text-4xl lg:text-5xl text-ink" />
            <Reveal delay={0.2} className="mt-10 grid md:grid-cols-2 gap-8 text-base text-mute leading-relaxed">
              <p>Reinigung ist Vertrauensarbeit. Wir bewegen uns in privaten Räumen, in Büros mit sensiblen Unterlagen, in Praxen mit hohen Hygieneanforderungen. Das prägt, wie wir auftreten und wie wir arbeiten.</p>
              <p>Unsere Abläufe sind einfach: klare Absprache, fester Plan, saubere Ausführung, Kontrolle. Keine Zwischenschichten, keine offenen Fragen. Wenn etwas nicht passt, sagen Sie es uns direkt, und wir lösen es.</p>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="bg-white py-24 md:py-36">
        <div className="container-x grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <ImageReveal src={IMG.quality.bath} alt="Badezimmer mit Naturstein" className="aspect-[4/5]" />
          </div>
          <div className="lg:col-span-6 lg:col-start-7 lg:pt-16">
            <p className="label text-mute mb-8">Wofür wir stehen</p>
            <ol className="border-t border-line">
              {VALUES.map(([t, d], i) => (
                <Reveal as="li" key={t} delay={i * 0.06} className="border-b border-line py-7 grid grid-cols-[3rem_1fr] gap-4">
                  <span className="label text-mute pt-1">0{i + 1}</span>
                  <span>
                    <span className="display text-2xl md:text-3xl text-ink block">{t}</span>
                    <span className="text-sm md:text-base text-mute leading-relaxed block mt-3">{d}</span>
                  </span>
                </Reveal>
              ))}
            </ol>
          </div>
        </div>
      </section>

      <Parallax src={IMG.positioning} alt="Wohnraum in warmen Tönen" className="h-[60vh]" amount={10} />
      <Trust />
      <FinalCta />
    </>
  );
}
